export default function (injection, Vue) {
    const util = {
        displayInCenter (img, dom, cb) {
            const callback = () => {
                process.nextTick(() => {
                    let w = img.width;
                    let h = img.height;
                    let pw = dom.offsetWidth;
                    let ph = dom.offsetHeight;
                    let iw, ih, mt, ml;
                    if (w < pw && h < pw) {
                        mt = (ph - h) / 2 + 'px';
                        ml = (pw - w) / 2 + 'px';
                        if (!cb) {
                            img.style.marginTop = mt;
                            img.style.marginLeft = ml;
                        }
                    } else {
                        if (w / h > pw / ph) {
                            iw = pw;
                            ih = h / w * iw;
                            mt = img.style.marginTop = (ph - ih) / 2 + 'px';
                        } else {
                            ih = ph;
                            iw = w / h * ih;
                            ml = img.style.marginLeft = (pw - iw) / 2 + 'px';
                        }
                        img.width = iw;
                        img.height = ih;
                        img.style.width = iw + 'px';
                        img.style.height = ih + 'px';
                    }
                    if (!cb) {
                        dom.appendChild(img);
                    } else {
                        cb(iw, ih, ml, mt);
                    }
                });
            };
            if (typeof img === 'string') {
                const newImg = new Image();
                newImg.onload = () => {
                    img = newImg;
                    callback();
                };
                newImg.src = img;
            } else {
                callback();
            }
        }
    };
    if (!HTMLCanvasElement.prototype.toBlob) {
        Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
            value: function (callback, type, quality) {
                var canvas = this;
                setTimeout(function () {
                    var binStr = atob(canvas.toDataURL(type, quality).split(',')[1]);
                    var len = binStr.length;
                    var arr = new Uint8Array(len);
                    for (var i = 0; i < len; i++) {
                        arr[i] = binStr.charCodeAt(i);
                    }
                    callback(new Blob([arr], {type: type || 'image/png'}));
                });
            }
        });
    }
    Object.defineProperties(injection, {
        image: {
            get () {
                return util;
            }
        }
    });
    Object.defineProperties(Vue.prototype, {
        $image: {
            get () {
                return util;
            }
        }
    });
}
